import { Route, NavigationGuardNext } from 'vue-router';

// this is a temporary guard that will go away after navigation.ts is removed
const convertSearchStrategyToCareType = (searchStrategy: string | string[] | undefined): string | undefined => {
  if (!searchStrategy || Array.isArray(searchStrategy)) {
    return undefined;
  }

  if (searchStrategy.endsWith('_job')) {
    return searchStrategy.replace('_job', '');
  }

  return searchStrategy;
};

const redirectMastheadSearchToJobSearch = (to: Route, _from: Route, next: NavigationGuardNext) => {
  const queryParams = to.query as Record<string, string | string[] | undefined>;
  const searchStrategy = queryParams.search_strategy;
  const mastheadZipcode = queryParams.masthead_zipcode;
  const careType = convertSearchStrategyToCareType(searchStrategy as string | undefined);
  const query: any = {};

  if (careType) {
    query.careType = careType;
  }

  if (mastheadZipcode) {
    query.zipcode = mastheadZipcode;
  }

  next({
    name: 'JobSearch',
    query,
    replace: true,
  });
};

export default redirectMastheadSearchToJobSearch;
